const EntitlementDetails = ({ t }) => {
  return (
    <section className="p-4 space-y-3 rounded-lg bg-sideBar">
      <h3 className="font-bold">{t("financialAccountDetails")}</h3>
      <div className="flex items-center">
        <div className="w-full space-y-2">
          <p className="text-primary">{t("employee")}:</p>
          <p>نورة العتيبي</p>
        </div>
        <div className="w-full space-y-2">
          <p className="text-primary">{t("jobTitle")}:</p>
          <p>محاسبة</p>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-full space-y-2">
          <p className="text-primary">{t("entitlementType")}:</p>
          <p className="text-xl font-semibold text-[#3872FA]">مكافأة</p>
        </div>
        <div className="w-full space-y-2">
          <p className="text-primary">{t("reason")}:</p>
          <p className="text-xl font-semibold">تحقيق مستهدف شهري</p>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-full space-y-2">
          <p className="text-primary">{t("amount")}:</p>
          <p className="text-xl font-semibold">1,000 JD</p>
        </div>
        <div className="w-full space-y-2">
          <p className="text-primary">{t("date")}:</p>
          <p className="text-[#11A849] text-xl font-semibold">10 يونيو 2025</p>
        </div>
      </div>
      <div className="flex items-center">
        <div className="w-full space-y-2">
          <p className="text-primary">{t("status")}:</p>
          <p className="text-[#11A849] text-xl font-semibold">مدفوع</p>
        </div>
        <div className="w-full space-y-2">
          <p className="text-primary">{t("additionSource")}:</p>
          <p className="text-xl font-semibold">يدوي (مدير الموارد البشرية)</p>
        </div>
      </div>
    </section>
  );
};

export default EntitlementDetails;
